/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import LocalizedText from 'commons/LocalizedText/LocalizedText';
import SkeletonLaboratoryGrid from 'components/Skeletons/SkeleronLaboratoryGrid/SkeletonLaboratoryGrid';
import { ProductTestTestedPoint } from './ProductTestTestedPoint';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/pro-solid-svg-icons';
import { TechnicalItemType } from 'components/TechnicalItemType/TechnicalItemType';


const useStyles = makeStyles((theme) => ({
  container: {
    padding: '50px 0'
  },
  generalPadding: {
    marginTop: theme.spacing(5)
  },
  title: {
    padding: '3px 10px',
    color: theme.palette.secondary.main,
    borderLeft: '5px solid',
    fontWeight: 'bold',
    fontSize: '120%'
  },
  openAll: {
    cursor: 'pointer',
    color: theme.palette.primary.main,
    fontWeight: 'bold'
  },
  openAllText: {
    textDecoration: 'underline'
  },
  legendContainer: {
    border: `0.5px dashed ${theme.palette.text.disabled}`,
    padding: '3px 15px'
  },
  oldValue:{
    color: theme.palette.text.disabled
  }
}));


export const ProductTestTestedPointsPage = ({
  productTestTestedPoints,
  onChange,
  isLoadingApplications,
  handleOpenTestedPoints,
  isAllOpen,
  setIsAllOpen
}) => {
  const classes = useStyles();

  const handleIsAllOpen = () => {
    setIsAllOpen(!isAllOpen);
  }

  return (
    !isLoadingApplications ?
      <div className={classes.generalPadding}>
        <Grid className={classes.columnContainer} container direction='column' spacing={2}>
          <Grid item>
            <Grid alignitem='center' container justifyContent='space-between'>
              <Grid item xs={4}>
                <LocalizedText className={classes.title}>
                  applications
                </LocalizedText>
              </Grid>
              <Grid item xs={6}>
                <Grid alignitem='center' className={classes.legendContainer} container justifyContent='space-evenly' spacing={1} wrap='nowrap'>
                  <Grid item><LocalizedText>legend</LocalizedText></Grid>
                  <Grid item>
                    <TechnicalItemType isTranslated type={'Performance'}/>
                  </Grid>
                  <Grid item>
                    <TechnicalItemType isTranslated type={'Characteristic'}/>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item onClick={handleIsAllOpen} xs={2}>
                <Grid alignitem='center' className={classes.openAll} container justifyContent='flex-end' spacing={1} wrap='nowrap'>
                  <Grid item>
                    <LocalizedText className={classes.openAllText}>
                      {isAllOpen ? 'closeAll' : 'openAll'}
                    </LocalizedText>
                  </Grid>
                  <Grid item>
                    <FontAwesomeIcon icon={isAllOpen? faChevronUp : faChevronDown}/>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <Grid alignitem='center' container direction='column' spacing={4}>
              {productTestTestedPoints.map(testedPoint =>
                <Grid item>
                  <ProductTestTestedPoint handleOpenTestedPoints={handleOpenTestedPoints} testedPoint={testedPoint}/>
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
      </div>
      :
      <SkeletonLaboratoryGrid className={classes.container} />
  );
};